import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { UrlPath } from '~/hooks';
import { Logger } from '../utils';

const getPathName = (path: string) => {
  let pathName;
  if (path === UrlPath.Home) {
    pathName = 'home';
  } else if (path.indexOf(UrlPath.FileAnApplication) === 0) {
    pathName = 'file an application';
  } else if (path.indexOf(UrlPath.FileThankYou) === 0) {
    pathName = 'ty-application';
  } else if (path.indexOf(UrlPath.MyApplication) === 0) {
    if (path === UrlPath.MyApplication) {
      pathName = 'my application';
    } else {
      pathName = 'my application details';
    }
  } else if (path.indexOf(UrlPath.GlobalStatus) === 0) {
    pathName = 'global ip status';
  } else if (path.indexOf(UrlPath.Watch) === 0) {
    pathName = 'watch';
  } else if (path.indexOf(UrlPath.TrademarkManagement) === 0) {
    pathName = 'trademarks';
  } else if (/\/application\/(.*[0-9])\/payment/.test(path)) {
    if (path.split('/').includes('ty')) {
      pathName = 'ty-payment';
    } else {
      pathName = 'payment';
    }
  }
  return pathName;
};

export const usePageview = (): void => {
  const [page, setPage] = useState<string>();
  const { pathname } = useLocation();
  const originPath = pathname.split('/')[1] === 'ko' ? pathname.slice(3) : pathname;

  useEffect(() => {
    const pathName = getPathName(originPath);
    if (pathName !== page) {
      if (pathName) {
        Logger.track(
          `viewed ${pathName}`,
          page
            ? {
                From: page,
              }
            : undefined
        );
      }
      setPage(pathName);
    }
  }, [originPath, page]);
};
